/** Minimal typed event emitter (no dependencies). */
export class Emitter<Events extends Record<string, unknown>> {
  private handlers = new Map<string, Set<(payload: never) => void>>();

  on<K extends keyof Events & string>(
    event: K,
    handler: (payload: Events[K]) => void
  ): () => void {
    let set = this.handlers.get(event);
    if (!set) {
      set = new Set();
      this.handlers.set(event, set);
    }
    set.add(handler as (payload: never) => void);
    return () => set!.delete(handler as (payload: never) => void);
  }

  emit<K extends keyof Events & string>(event: K, payload: Events[K]): void {
    this.handlers.get(event)?.forEach((h) => {
      try {
        (h as (payload: Events[K]) => void)(payload);
      } catch (err) {
        console.error(`[deutero] ${event} handler failed`, err);
      }
    });
  }

  clear(): void {
    this.handlers.clear();
  }
}
